import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNotify } from '@/components/snackbar';
import { getNotifications, readAllNotifications } from '../services/notifications';
import { BACKGROUND_QUERY_META } from '../utils/backgroundQuery';

// `background` é do popover do header: na página de notificações a lista é o
// conteúdo da tela, e a porta de transição precisa esperar por ela.
const useNotifications = ({ page = 1, search = '', background = false }) => {
  const notify = useNotify();

  const {
    data: { results: notifications = [], count } = {},
    isFetching: fetching,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ['notifications', { page, search }],
    queryFn: () => getNotifications({ page, search }),
    initialData: {
      results: [],
      count: 0,
    },
    meta: background ? BACKGROUND_QUERY_META : undefined,
  });

  const queryClient = useQueryClient();

  const { mutateAsync: readAll, isLoading: reading } = useMutation(readAllNotifications, {
    onSuccess: () => {
      queryClient.invalidateQueries('notifications');
    },
    onError: () => {
      notify.error('Erro ao ler notificações');
    },
  });

  const unread = notifications?.filter((item) => item.read === false).length;

  return { notifications, fetching, isError, error, refetch, readAll, reading, unread, count };
};

export default useNotifications;
